import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { FloatLabelModule } from 'primeng/floatlabel';
import { MultiSelectModule } from 'primeng/multiselect';

import { FloatLabelVariant } from '../ui-types';
import { createGuid } from '../../utils/guid';

@Component({
  selector: 'multi-select',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CheckboxModule, FloatLabelModule, MultiSelectModule],
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss',
})
export class MultiSelectComponent implements OnInit {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() options: { id: string; displayValue: string }[] = [];
  @Input({ required: true }) control!: FormControl;
  @Input() variant?: FloatLabelVariant = 'in';
  @Input() errorMessage?: string;
  @Input() displayAsCheckboxList = false;

  id?: string;

  ngOnInit(): void {
    if (this.hasLabel()) {
      this.id = createGuid('multi_checkbox');
      return;
    }
    this.variant = 'over';
  }

  hasLabel(): boolean {
    return !!this.label && this.label.length > 0;
  }

  isChecked(optionId: string): boolean {
    const value = this.control.value;
    return Array.isArray(value) && value.includes(optionId);
  }

  onCheckboxChange(optionId: string, checked: boolean): void {
    const currentValue = this.control.value;
    const values = Array.isArray(currentValue) ? [...currentValue] : [];

    if (checked && !values.includes(optionId)) {
      values.push(optionId);
    }

    if (!checked) {
      const index = values.indexOf(optionId);
      if (index > -1) {
        values.splice(index, 1);
      }
    }

    this.control.setValue(values);
    this.control.markAsDirty();
    this.control.markAsTouched();
  }
}
